import React from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

// create styles
// create page styles
const styles = (theme) => ({
  root: {
    backgroundColor: `rgba(49,49,49,1)`,
    borderRadius: 4,
    zIndex: 1200,
    padding: 15,
    maxWidth: 300,
  },
  popoverTitle: {
    color: theme.palette.primary.main,
  },
  popoverSubtitle: {
    color: `#ffffff`,
  },
  popoverListItem: {
    marginTop: 5,
    display: `flex`,
    color: `#ffffff`,
  },
  popoverSymbolPoint: {
    border: `1.5px solid #333333`,
    borderRadius: `50%`,
    width: 20,
    height: 20,
  },
  popoverText: {
    marginLeft: 5,
    fontSize: "0.8rem",
  },
  noDataText: {
    color: `#c2c2c2`,
    marginTop: 5,
  },
});

const BenchmarkPopoverReportCard = ({ classes, data, lowIsBad }) => {
  const popoverColors = [
    typeof data.bmk_line3 === "number"
      ? {
          name: `>${data.bmk_line3} ${data.units}`,
          color: "#FF0000",
        }
      : "",
    typeof data.bmk_line2 === "number" && typeof data.bmk_line3 === "number"
      ? {
          name: `${data.bmk_line2} - ${data.bmk_line3} ${data.units}`,
          color: "#FFA500",
        }
      : "",
    typeof data.bmk_line1 === "number" && typeof data.bmk_line2 === "number"
      ? {
          name: `${data.bmk_line1} - ${data.bmk_line2} ${data.units}`,
          color: "#FFFF00",
        }
      : "",
    typeof data.bmk_line0 === "number" && typeof data.bmk_line1 === "number"
      ? {
          name: `${data.bmk_line0} - ${data.bmk_line1} ${data.units}`,
          color: "#3CB371",
        }
      : "",
    typeof data.bmk_line0 === "number"
      ? {
          name: `${data.parameter_abbrev} below detection limits`,
          color: "#AFEEEE",
        }
      : {
          name: `No benchmarks available`,
          color: "#6495ED",
        },
  ];

  const popoverColorsReverse = [
    typeof data.bmk_line0 === "number"
      ? { name: `>${data.bmk_line0} ${data.units}`, color: "#AFEEEE" }
      : "",
    typeof data.bmk_line0 === "number" && typeof data.bmk_line1 === "number"
      ? {
          name: `${data.bmk_line1} - ${data.bmk_line0}  ${data.units}`,
          color: "#3CB371",
        }
      : "",
    typeof data.bmk_line1 === "number" && typeof data.bmk_line2 === "number"
      ? {
          name: `${data.bmk_line2} - ${data.bmk_line1} ${data.units}`,
          color: "#FFFF00",
        }
      : "",
    typeof data.bmk_line2 === "number" && typeof data.bmk_line3 === "number"
      ? {
          name: `${data.bmk_line3} - ${data.bmk_line2}  ${data.units}`,
          color: "#FFA500",
        }
      : "",
    typeof data.bmk_line3 === "number" && typeof data.bmk_line4 === "number"
      ? {
          name: `${data.bmk_line4} - ${data.bmk_line3} ${data.units}`,
          color: "#FF0000",
        }
      : "",
  ];

  return (
    <div className={classes.root}>
      <div className="mb6">
        <Typography
          variant="h6"
          color="secondary"
          className={classes.popoverTitle}
        >
          {`${data.parameter} Benchmarks`}
        </Typography>
        <div className={classes.popoverList}>
          {lowIsBad
            ? popoverColorsReverse.map((el) =>
                el ? (
                  <div className={classes.popoverListItem} key={el.name}>
                    <div
                      className={classes.popoverSymbolPoint}
                      style={{ backgroundColor: el.color }}
                    />
                    <div className={classes.popoverText}>{el.name}</div>
                  </div>
                ) : null
              )
            : popoverColors.map((el) =>
                el ? (
                  <div className={classes.popoverListItem} key={el.name}>
                    <div
                      className={classes.popoverSymbolPoint}
                      style={{ backgroundColor: el.color }}
                    />
                    <div className={classes.popoverText}>{el.name}</div>
                  </div>
                ) : null
              )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(
  BenchmarkPopoverReportCard
);
